jQuery(document).ready(function ($) {
  $('#mailerlite-form').on('submit', function (event) {
    event.preventDefault() // Zapobiega domyślnemu przeładowaniu strony

    var form = $(this)
    var messageContainer = $('#message-container')
    var formData = form.serialize() // Pobiera dane z formularza
    // Dodaj nonce do danych formularza
    formData += '&security=' + themeData.subscribe_nonce

    // Wyślij żądanie AJAX
    $.ajax({
      url: themeData.ajax_url,
      type: 'POST',
      dataType: 'json',
      data: formData,
      beforeSend: function () {
        // Pokaż loader lub zablokuj przycisk
        messageContainer.html('<p>Processing...</p>') // Dodaj jakiś wskaźnik ładowania
        form.find('button').prop('disabled', true) // Zablokuj przycisk
      },
      success: function (response) {
        if (response.success) {
          $('#message-container').html(
            '<p class="success">' + response.data.message + '</p>'
          )
          setTimeout(function () {
            $('#message-container').html('')
          }, 4000)

          $('#mailerlite-form')[0].reset()
        } else {
          $('#message-container').html(
            '<p class="error">' + response.data.message + '</p>'
          )
          setTimeout(function () {
            $('#message-container').html('')
          }, 3000)
          $('#mailerlite-form')[0].reset()
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        // Błąd połączenia lub inny błąd
        messageContainer.html(
          '<p class="error">An error occurred: ' +
            textStatus +
            ' - ' +
            errorThrown +
            '</p>'
        )
        console.log(jqXHR, textStatus, errorThrown) //Wypisz błąd do konsoli przeglądarki.
      },
      complete: function () {
        // Odblokuj przycisk
        form.find('button').prop('disabled', false)
      },
    })
  })
})
